const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3001";
const getToken = () => localStorage.getItem("admin_token");
const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  "Content-Type": "application/json",
});
const df = {
  "& .MuiOutlinedInput-root": {
    color: "#fff",
    "& fieldset": { borderColor: "#555" },
  },
  "& .MuiInputLabel-root": { color: "#aaa" },
};


export { API_BASE, getToken, authHeaders, df };
